export enum RequisitesTabs {
  Requisites = 'requisites',
  Groups = 'groups',
  LimitsUpdatesHistory = 'limits-updates-history',
  Limits = 'limits',
  TelegramAutomation = 'telegram-automation',
}
